var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDark1440(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1806,
    height: 790,
    viewBox: "0 0 1806 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2167_11558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1214.19 340.962L1233.77 401.728H1297.14L1245.87 439.283L1265.46 500.049L1214.19 462.494L1162.92 500.049L1182.5 439.283L1131.23 401.728H1194.61L1214.19 340.962Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2167_11558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1802.78 399.49L1579.1 162.157L1263.27 238.343L1465.09 468.055L1802.78 399.49Z",
    fill: "url(#paint0_linear_2167_11558)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_2167_11558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1695.99 712.808L1802.78 399.49L1465.09 468.055L1365.82 766.835L1695.99 712.808Z",
    fill: "url(#paint1_linear_2167_11558)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_2167_11558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1163.9 544.442L1263.27 238.343L1465.09 468.055L1365.82 766.835L1163.9 544.442Z",
    fill: "url(#paint2_linear_2167_11558)",
    fillOpacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2167_11558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1466.57 467.943L1264.05 238.678L1579.29 162.257L1802.82 399.164L1466.57 467.943ZM1466.57 467.943L1365.31 765.988",
    stroke: "white",
    strokeWidth: 1.8051
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2167_11558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1261.91 154.602L1282.57 217.972H1349.41L1295.33 257.137L1315.99 320.508L1261.91 281.343L1207.84 320.508L1228.49 257.137L1174.42 217.972H1241.26L1261.91 154.602Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_2167_11558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1603.95 261.418L1623.8 322.184H1688.04L1636.07 359.739L1655.92 420.505L1603.95 382.95L1551.98 420.505L1571.83 359.739L1519.86 322.184H1584.1L1603.95 261.418Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_2167_11558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5651 144.42L60.5444 166.078H83.1302L64.8579 179.463L71.8373 201.121L53.5651 187.735L35.2929 201.121L42.2722 179.463L24 166.078H46.5857L53.5651 144.42Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_2167_11558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.345 165.279L183.624 80.6914L71.0586 107.845L142.989 189.716L263.345 165.279Z",
    fill: "url(#paint3_linear_2167_11558)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_ii_2167_11558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.283 276.948L263.346 165.279L142.99 189.716L107.608 296.204L225.283 276.948Z",
    fill: "url(#paint4_linear_2167_11558)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_ii_2167_11558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6407 216.94L71.0587 107.844L142.989 189.715L107.607 296.203L35.6407 216.94Z",
    fill: "url(#paint5_linear_2167_11558)",
    fillOpacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_2167_11558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.515 189.677L71.3361 107.965L183.69 80.7275L263.359 165.163L143.515 189.677ZM143.515 189.677L107.426 295.903",
    stroke: "white",
    strokeWidth: 1.8051
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_2167_11558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5753 78L77.9371 100.586H101.76L82.487 114.544L89.8488 137.13L70.5753 123.171L51.3019 137.13L58.6637 114.544L39.3903 100.586H63.2135L70.5753 78Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_2167_11558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.481 116.07L199.556 137.728H222.451L203.928 151.113L211.003 172.77L192.481 159.385L173.958 172.77L181.033 151.113L162.51 137.728H185.406L192.481 116.07Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2167_11558",
    x: 1013.9,
    y: 223.63,
    width: 400.569,
    height: 393.751,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58.6658,
    result: "effect1_foregroundBlur_2167_11558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2167_11558",
    x: 1263.27,
    y: 162.157,
    width: 539.51,
    height: 340.478,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 34.5797
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44.9536
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2167_11558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_2167_11558",
    x: 1356.79,
    y: 399.49,
    width: 449.599,
    height: 374.566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -9.02551
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.533333 0 0 0 0 0.705882 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2167_11558"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.61021,
    dy: 7.22041
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.8816
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2167_11558",
    result: "effect2_innerShadow_2167_11558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_2167_11558",
    x: 1156.68,
    y: 223.902,
    width: 310.22,
    height: 556.765,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.8051,
    dy: 13.8319
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.6612
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.647059 0 0 0 0 0.494118 0 0 0 0 0.980392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2167_11558"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.22041,
    dy: -14.4408
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.6612
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2167_11558",
    result: "effect2_innerShadow_2167_11558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2167_11558",
    x: 1238.92,
    y: 137.79,
    width: 589.142,
    height: 651.955,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.7332,
    result: "effect1_foregroundBlur_2167_11558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2167_11558",
    x: 1097.11,
    y: 77.3009,
    width: 329.598,
    height: 320.508,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.6506,
    result: "effect1_foregroundBlur_2167_11558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_2167_11558",
    x: 1451.15,
    y: 192.706,
    width: 305.602,
    height: 296.512,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.3561,
    result: "effect1_foregroundBlur_2167_11558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_2167_11558",
    x: -93.3317,
    y: 27.0887,
    width: 293.793,
    height: 291.364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58.6658,
    result: "effect1_foregroundBlur_2167_11558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_2167_11558",
    x: 71.0586,
    y: 80.6914,
    width: 192.286,
    height: 143.605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 34.5797
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44.9536
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2167_11558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_ii_2167_11558",
    x: 98.5824,
    y: 165.279,
    width: 168.373,
    height: 138.146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -9.02551
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.533333 0 0 0 0 0.705882 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2167_11558"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.61021,
    dy: 7.22041
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.8816
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2167_11558",
    result: "effect2_innerShadow_2167_11558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_ii_2167_11558",
    x: 28.4203,
    y: 93.4029,
    width: 116.374,
    height: 216.632,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.8051,
    dy: 13.8319
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.6612
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.647059 0 0 0 0 0.494118 0 0 0 0 0.980392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2167_11558"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.22041,
    dy: -14.4408
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.6612
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2167_11558",
    result: "effect2_innerShadow_2167_11558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_2167_11558",
    x: 46.2022,
    y: 56.2607,
    width: 242.392,
    height: 263.398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.7332,
    result: "effect1_foregroundBlur_2167_11558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_2167_11558",
    x: -37.9109,
    y: 0.698868,
    width: 216.972,
    height: 213.733,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.6506,
    result: "effect1_foregroundBlur_2167_11558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_2167_11558",
    x: 93.7984,
    y: 47.3582,
    width: 197.364,
    height: 194.124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.3561,
    result: "effect1_foregroundBlur_2167_11558"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2167_11558",
    x1: 1658.51,
    y1: 243.775,
    x2: 1378.06,
    y2: 408.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2167_11558",
    x1: 1765.48,
    y1: 450.221,
    x2: 1373.04,
    y2: 774.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2167_11558",
    x1: 1428.69,
    y1: 452.913,
    x2: 1006.87,
    y2: 783.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2167_11558",
    x1: 211.925,
    y1: 109.781,
    x2: 111.972,
    y2: 168.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2167_11558",
    x1: 250.051,
    y1: 183.36,
    x2: 110.181,
    y2: 298.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2167_11558",
    x1: 130.018,
    y1: 184.319,
    x2: -20.3236,
    y2: 302.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDark1440);
export default __webpack_public_path__ + "static/media/ic_dark-1440.20ce0d09a41064c6fd773a6bb1e63e2f.svg";
export { ForwardRef as ReactComponent };